export default "__VITE_ASSET__COS4Gn_g__"